import type { AssertDuringMigration } from '@core/types/typeMigrationHelpers'

// Currently, we have only two levels, essential and non essential. In future,
// we may go more granular and split non-essential to different groups, ie.
// analytics, advertising, performance and such
export const consents = ['essential', 'non-essential'] as const
export type Consent = (typeof consents)[number]

export interface PixelTrackingEndpoint {
  url: string
  isUserEngagement: boolean
  consent: Consent
}

export interface ISendPixelTracking {
  endpoint: PixelTrackingEndpoint
  data: Record<string, AssertDuringMigration>
  host: string | undefined
}
